<template>
  <router-view></router-view>
</template>

<script>
function isTruthyQueryParam(value) {
  return value === 'true' || value === '1';
}

export default {
  name: 'App',
  mounted() {
    const urlParams = new URLSearchParams(window?.location?.search);
    const isInverseTheme = isTruthyQueryParam(urlParams.get('inverse'));

    document.documentElement.classList.toggle('inverse-theme', isInverseTheme);
    document.body.classList.toggle('inverse-theme', isInverseTheme);

    if(urlParams.get('app') === '1') {
      import('./assets/css/app.css').then(() => {
        console.log('Stile importato con successo');
      }).catch(err => {
        console.error('Errore nell\'importazione dello stile:', err);
      });
    }
  },
  beforeUnmount() {
    document.documentElement.classList.remove('inverse-theme');
    document.body.classList.remove('inverse-theme');
  }
}
</script>

<style>
@import './assets/css/style.css';
</style>
